// GENEROWANE z opisu linii w workerze Go: `worker tool typy` (worker-go/tools/typy).
// Nie edytować ręcznie - zmiana kontraktu = zmiana opisu w Go i ponowne wygenerowanie (KN-2).

import type { ViewDoc } from "../kontrakt";

export interface PolaTermometrT4 {
  g1_w: number | null;
  g2_w: number | null;
  power_w: number | null;
  ch1: number | null;
  ch1_alarm: boolean | null;
  ch2: number | null;
  ch2_alarm: boolean | null;
  ch3: number | null;
  ch3_alarm: boolean | null;
  ch4: number | null;
  ch4_alarm: boolean | null;
  pressure_hpa: number | null;
  boil_correction: number | null;
  boil_temp: number | null;
}

export interface NastawyTermometrT4 {
  nazwa10pSET: string | null;
  SETalarm10p: number | null;
  alarm10pTyp: boolean | null;
  kor10p: number | null;
  nazwaZbiornikSET: string | null;
  SETalarmZbiornik: number | null;
  alarmZbiornikTyp: boolean | null;
  korZbiornik: number | null;
  nazwaUFOSET: string | null;
  SETalarmUFO: number | null;
  alarmUFOTyp: boolean | null;
  korUFO: number | null;
  nazwaBuforSET: string | null;
  SETalarmBufor: number | null;
  alarmBuforTyp: boolean | null;
  korBufor: number | null;
  G1: number | null;
  G2: boolean | null;
}

export interface WidokTermometrT4 extends Omit<ViewDoc, "fields" | "settings" | "no_sensor" | "state"> {
  type: "termometr-t4";
  state?: string;
  fields: PolaTermometrT4;
  settings?: NastawyTermometrT4;
  no_sensor?: Array<keyof PolaTermometrT4>;
}

export const KOMENDY_TERMOMETRT4 = {
  "nastawy": {
    "G1": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "G2": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "SETalarm10p": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 150,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "SETalarmBufor": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 150,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "SETalarmUFO": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 150,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "SETalarmZbiornik": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 150,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "alarm10pTyp": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "alarmBuforTyp": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "alarmUFOTyp": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "alarmZbiornikTyp": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "kor10p": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "korBufor": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "korUFO": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "korZbiornik": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "nazwa10pSET": {
      "rodzaj": "tekst",
      "maks_dl": 32,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "nazwaBuforSET": {
      "rodzaj": "tekst",
      "maks_dl": 32,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "nazwaUFOSET": {
      "rodzaj": "tekst",
      "maks_dl": 32,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "nazwaZbiornikSET": {
      "rodzaj": "tekst",
      "maks_dl": 32,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    }
  },
  "akcje": {
    "fabryczne": {
      "poziom": "niszczaca",
      "skutek": "parowanie",
      "czas_s": 60
    },
    "reset": {
      "poziom": "restart",
      "skutek": "online",
      "czas_s": 180
    },
    "resetWiFi": {
      "poziom": "niszczaca",
      "skutek": "parowanie",
      "czas_s": 60
    }
  },
  "czas_potwierdzenia_s": 10
} as const;

/** Kanały wykresu (numer w próbkach i w punkcie na żywo `widok.wykres`) z nazwą domyślną z opisu linii. */
export const KANALY_TERMOMETRT4 = [
  {
    "idx": 0,
    "nazwa": "10-ta półka",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 1,
    "nazwa": "Zbiornik",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 2,
    "nazwa": "UFO",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 3,
    "nazwa": "Bufor",
    "ukryty": false,
    "zimny": false
  }
] as const;

/** Progi koloru temperatury (KN-20): poziom = liczba progów ≤ wartości, kolor `--iot-temp-<poziom+1>`. */
export const PROGI_KOLORU_TERMOMETRT4 = [35,70,78,86,93] as const;

/** Parametry sztuki od klienta (GET/PATCH /brama/urzadzenia/{sn}/sprzet): klucz → zakres i krok liczby
 *  albo lista wartości tekstu. */
export const SPRZET_TERMOMETRT4 = {
  "g1_w": {
    "min": 0,
    "max": 20000,
    "krok": 0.01
  },
  "g2_w": {
    "min": 0,
    "max": 20000,
    "krok": 0.01
  }
} as const;

